// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payee-filter-row {
  margin-bottom: 1.8rem;
}
.payee-filter-row .filter-item {
  display: flex;
  flex-direction: column;
  width: 20rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/PayeeFilter/index.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AACJ","sourcesContent":[".payee-filter-row {\n  margin-bottom: 1.8rem;\n\n  .filter-item {\n    display: flex;\n    flex-direction: column;\n    width: 20rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
